export function useFetchContext(): FetchContext {
  const { $auth, $i18n } = useNuxtApp();
  const config = useRuntimeConfig();
  const appStore = useAppStore();
  const globalNotification = useGlobalNotification();

  const apiUrl = computed(() => config.public.API_URL);
  const activeFacilityId = computed(() => appStore.activeFacilityId);

  return {
    apiUrl,
    $i18n,
    $auth,
    activeFacilityId,
    runProcess: appStore.startProcess,
    getNotificationError: globalNotification.getError,
    addNotificationMessage: globalNotification.showError,
    showErrorMessage: (m) => console.log(`🌐 ${m}`),
    showDevErrorMessage: (m) => devConsole.log(`🌐 ${m}`),
    showPending: globalNotification.showPending,
  };
}
